import { Shark, View } from "shark-mvc";

import ImageContent from "../../models/ImageContent";
import ImageExifData from "../../models/ImageExifData";

import templateContent from "./images-bulk-upload.html";

import imageContentManager from "../../controllers/imageContentManager";
import mainNavComponent from "../../components/mainNav/mainNavComponent";
import referenceVolumesComponent from "../../components/referenceVolumes/referenceVolumesComponent";
import waitBoxComponent from "../../components/waitBox/waitBoxComponent";

class ImagesBulkUploadView extends View {
	constructor () {
		super("imagesBulkUploadView");
		this.setTemplate(templateContent);
	}

	afterLoad () {
		referenceVolumesComponent.setup();	
	}
	
	beforeLoad () {	
		Shark.set({
			bulkSavedImagesList: [],
		});
	}

	bulkUploadField_changeHandler (event) {
		Shark.set({
			bulkImageFileList: Array.from(event.target.files),
		});
		//	this.uploadFile(event.target);
	}

	checkMissingImage () {
		const { bulkImageFileList, inDesingExportedImageList, lastInDesignExportedImageListFileName } = Shark.get();

		if (bulkImageFileList.length === 0) {
			alert("Devi selezionare delle immagini");
			return;
		}

		if (inDesingExportedImageList.length === 0) {
			alert("Devi inserire la lista delle immagini da InDesing.");
			return;
		}

		const missingFileList = inDesingExportedImageList.filter(idFile => !bulkImageFileList.find(file => idFile.url === file.name));
		const missingWrongFormatFileList = missingFileList.filter(idFile => idFile.url.slice(-3).toLowerCase() !== "jpg" && idFile.url.slice(-4).toLowerCase() !== "jpeg");
		const missingInDesignImage = bulkImageFileList.filter(file => !inDesingExportedImageList.find(idFile => idFile.url === file.name));
		const missingWronfFormatInDesignImage = missingInDesignImage.filter(file => file.name.slice(-3).toLowerCase() !== "jpg" && file.name.slice(-4).toLowerCase() !== "jpeg");

		console.log({missingFileList, missingInDesignImage});

		if (missingFileList.length > 0 || missingInDesignImage.length > 0) {
			if (missingFileList.length > 0) {
				if (confirm(`Mancano ${missingFileList.length} file (di cui ${missingWrongFormatFileList.length} non JPEG) rispetto alla lista di InDesing, vuoi esportare una nuova lista per processarla in seguito?`)) {
					const missingFileListFileContent = missingFileList.map(item => `${item.page},${item.url}`).join("\n");
					console.log(missingFileListFileContent);

					const link = document.createElement("a");
					const file = new Blob([missingFileListFileContent], { type: "text/plain" });
					link.href = URL.createObjectURL(file);
					link.download = lastInDesignExportedImageListFileName.replace(".txt", " - Missing 1.txt");
					link.click();
					URL.revokeObjectURL(link.href);
				}
			}
			if (missingInDesignImage.length > 0) {
				if (confirm(`Nella lista di InDesig mancano ${missingInDesignImage.length} file (di cui ${missingWronfFormatInDesignImage.length} non JPEG) rispetto ai file che hai selezionato (hai dei file non presenti nella lista), vuoi esportare una nuova lista per segnalare l'errore?`)) {
					const missingFileListFileContent = missingInDesignImage.map(item => `${item.name}`).join("\n");
					console.log(missingFileListFileContent);

					const link = document.createElement("a");
					const file = new Blob([missingFileListFileContent], { type: "text/plain" });
					link.href = URL.createObjectURL(file);
					link.download = lastInDesignExportedImageListFileName.replace(".txt", " - Unused files 1.txt");
					link.click();
					URL.revokeObjectURL(link.href);
				}
			}
		}
		else {
			alert("Tutto a posto!");
		}
	}
	
	checkMissingImageBtn_clickHandler () {
		this.checkMissingImage();
	}

	inDesingExportedImageListFileField_changeHandler (event) {
		const { imagesBulkUploadSettings } = Shark.get();
		const file = event.target.files[0];
		const fileReader = new FileReader();

		fileReader.addEventListener("load", () => {
			imagesBulkUploadSettings.set({
				inDesingExportedImageListRaw: fileReader.result,
			});

			const inDesingExportedImageList = imagesBulkUploadSettings?.inDesingExportedImageListRaw.split("\n").map(item => {
				const parts = item.trim().replace("\r", "").split(",");
				
				return {
					page: parts[0],
					url: parts[1],
				};
			});

			Shark.set({
				inDesingExportedImageList,
				lastInDesignExportedImageListFileName: file.name,
			});
		});

		fileReader.readAsText(file);
	}

	init () {
		this.addComponents([mainNavComponent, referenceVolumesComponent, waitBoxComponent]);

		const imagesBulkUploadSettings = Shark.getInstance("__smart__", {
			inDesingExportedImageListRaw: "",
			referenceVolumeRaw: "",
		});

		imagesBulkUploadSettings.on("dataChanged", (event, data) => {
			if (data.property === "referenceVolumeRaw") {
				// volumeManager.get
			}
		});

		Shark.set({
			bulkImageFileList: [],
			bulkSavedImagesList: [],
			imagesBulkUploadSettings,
			inDesingExportedImageList: [],
			skippedFileList: [],
		});
	}

	async processImages () {
		const { bulkSavedImagesList, bulkImageFileList, imagesBulkUploadSettings, inDesingExportedImageList } = Shark.get();

		if (bulkImageFileList.length === 0) {
			alert("Devi selezionare delle immagini");
			return;
		}

		if (imagesBulkUploadSettings.referenceVolumeRaw.trim() === "") {
			alert("Devi inserire un volume di riferimento");
			return;
		}

		if (imagesBulkUploadSettings.inDesingExportedImageListRaw.trim() === "") {
			alert("Devi inserire la lista delle immagini da InDesing.");
			return;
		}

		waitBoxComponent.setCustomMessage(`Ho inviato ${bulkSavedImagesList.length}/${bulkImageFileList.length} immagini.`);
		waitBoxComponent.open();

		// const inDesingExportedImageList = imagesBulkUploadSettings?.inDesingExportedImageListRaw.split("\n").map(item => {
		// 	const parts = item.trim().replace("\r", "").split(",");
			
		// 	return {
		// 		page: parts[0],
		// 		url: parts[1],
		// 	};
		// });

		console.log({inDesingExportedImageList});

		const referenceVolume = imagesBulkUploadSettings.referenceVolumeRaw;
		const uploadReportData = [];
		const skippedFileList = [];

		// bulkImageFileList.forEach(async file => {
		for (let file of bulkImageFileList) {
			const fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
			
			if (["ai", "eps"].includes(fileExtension)) {
				skippedFileList.push({name: file.name, reason: "Unsupported format"});
				continue;
			}

			if (file.size > 75 * 1024 * 1024) {
				skippedFileList.push({name: file.name, reason: "File too big"});
				continue;
			}

			const imagePage = inDesingExportedImageList.find(item => item.url === file.name);

			console.log(file.name, imagePage?.page || "******************");

			if (imagePage?.page) {
				const existingImageResponse = await imageContentManager.getByOriginalFileName(file.name);
				console.log({existingImageResponse});
				if (existingImageResponse.data.length > 0) {
					const existingImage = new ImageContent(existingImageResponse.data[0]);
					console.log({existingImage});

					uploadReportData.push({
						datetime: new Date().toISOString(),
						fileName: file.name,
						existing: true,
						existingGuid: existingImage.guid,
						insertedGuid: "",
					});

					existingImage.__alredyExistingCSSClass = "table-warning";

					bulkSavedImagesList.unshift(existingImage);
					waitBoxComponent.setCustomMessage(`Ho inviato ${bulkSavedImagesList.length}/${bulkImageFileList.length} immagini.`);
					
					Shark.set({
						bulkSavedImagesList,
					});	
				}
				else {
					const uploadResponse = await this.uploadSingleFile(file, `volume-pictures/${referenceVolume.toLowerCase().replace(/ /, "-")}`);
					const currImage = uploadResponse.payload.items[0];

					// fileByteSize: currImage?.mainResizeResult?.fileSize || currImage.size,
					// fileIntrinsicHeight: currImage?.resizedImageInfo?.height || currImage.imageInfo.height,
					// fileIntrinsicWidth: currImage?.resizedImageInfo?.width || currImage.imageInfo.width,
					// source: imageContentManager.extractSource(exifData.Copyright, currImage.name),
					// originalFileName: currImage.name,
					// 	fileByteSize: currImage.size,
					// 	height: currImage.imageInfo.height,
					// 	width: currImage.imageInfo.width,
					console.log({uploadResponse});

					if (uploadResponse.status === "success") {
						const newImageContent = new ImageContent({
							createdByGuid: Shark.$store.currUser.guid,
							extraData: {
								needReview: true,
							},
							fileThumbnailURL: currImage.thumbnailPath,
							fileURL: currImage.filePath,
							referenceVolumes: [{ value: referenceVolume }],
							tags: `[{"value":"pag${imagePage.page.toString().padStart(3, "0")}"}]`,
						});
						
						const updatedContent = await imageContentManager.extractAndAddImageAndExifData(file, newImageContent);
						console.log({updatedContent});

						updatedContent.set({
							fileByteSize: currImage?.mainResizeResult?.fileSize || currImage.size,
							fileIntrinsicHeight: currImage?.resizedImageInfo?.height || currImage.imageInfo.height,
							fileIntrinsicWidth: currImage?.resizedImageInfo?.width || currImage.imageInfo.width,
						});
						
						const saveResponse = await imageContentManager.save(updatedContent);
						console.log({saveResponse});
						
						updatedContent.__alredyExistingCSSClass = "table-success";
			
						uploadReportData.push({
							datetime: new Date().toISOString(),
							fileName: file.name,
							existing: false,
							existingGuid: "",
							insertedGuid: updatedContent.guid,
						});
	
						Shark.set({
							currContent: updatedContent,
						});

						const bulkSavedImagesList = Shark.$store.bulkSavedImagesList;
						bulkSavedImagesList.unshift(Shark.$store.currContent);
						waitBoxComponent.setCustomMessage(`Ho inviato ${bulkSavedImagesList.length}/${bulkImageFileList.length} immagini.`);
						
						Shark.set({
							bulkSavedImagesList,
						});	
					}
				}
			}
			else {
				console.warn("PAGINA MANCANTE", file);
			}
		}

		Shark.set({
			uploadReportData,
			skippedFileList,
		});

		waitBoxComponent.close();

		this.saveUploadReport();
	}
	
	processImagesBtn_clickHandler () {
		this.processImages();
	}

	saveLastProcessReportBtn_clickHandler () {
		this.saveUploadReport();
	}

	saveUploadReport () {
		const { lastInDesignExportedImageListFileName, uploadReportData } = Shark.get();

		if (uploadReportData) {
			const link = document.createElement("a");
			const file = new Blob([JSON.stringify(uploadReportData)], { type: "application/json" });
			link.href = URL.createObjectURL(file);
			link.download = lastInDesignExportedImageListFileName.replace(".txt", " - report.json");
			link.click();
			URL.revokeObjectURL(link.href);
		}
	}

	async uploadFile (inputField) {
		if (inputField.files.length >= 1) {
			waitBoxComponent.open();
			const { imagesBulkUploadSettings } = Shark.get();
	
			console.log("uploadFile ==== inputField.files.length -> ", inputField.files.length);
			console.log("uploadFile ==== inputField.files -> ", inputField.files);

			const filesArray = Object.values(inputField.files);
			const referenceVolume = imagesBulkUploadSettings.referenceVolumeRaw;

			for (const file of filesArray) {
				const uploadResponse = await this.uploadSingleFile(file);
				console.log("****1**** uploadFile ==== uploadResponse -> ", {uploadResponse});
				
				if (uploadResponse.status === "success") {
					const currImage = uploadResponse.payload.items[0];
					const exifData = new ImageExifData(currImage.exif);
					console.log("****2**** uploadFile ==== ImageExifData -> ", exifData);
					
					const currContent = new ImageContent({
						createdByGuid: Shark.$store.currUser.guid,
					});

					currContent.set({
						authorName: exifData.Artist,
						copyright: exifData.Copyright,
						__exifCreationDate: exifData.DateTime,
						description: exifData.ImageDescription,
						extraData: {
							needReview: true,
						},
						fileType: exifData.MimeType,
						fileByteSize: currImage?.mainResizeResult?.fileSize || currImage.size,
						fileIntrinsicHeight: currImage?.resizedImageInfo?.height || currImage.imageInfo.height,
						fileIntrinsicWidth: currImage?.resizedImageInfo?.width || currImage.imageInfo.width,
						fileThumbnailURL: currImage.thumbnailPath,
						// fileType: currImage.imageInfo.mime,
						fileURL: currImage.filePath,
						source: imageContentManager.extractSource(exifData.Copyright, currImage.name),
						originalExifData: exifData || {},
						originalFileName: currImage.name,
						originalImageInfo: {
							authorName: exifData.Artist,
							fileByteSize: currImage.size,
							height: currImage.imageInfo.height,
							width: currImage.imageInfo.width,
						},
						referenceVolumes: [{ value: referenceVolume }],
					});

					Shark.set({
						currContent,
					});

					const saveResponse = await imageContentManager.save(Shark.$store.currContent);
					
					console.log("****3**** uploadFile ==== Uploaded -> ", Shark.$store.currContent);
					console.log("****4**** uploadFile ==== SaveResponse -> ", {saveResponse});

					const bulkSavedImagesList = Shark.$store.bulkSavedImagesList;
					console.log("****5**** uploadFile ==== bulkSavedImagesList before -> ", bulkSavedImagesList);
					bulkSavedImagesList.unshift(Shark.$store.currContent),
					console.log("****6**** uploadFile ==== bulkSavedImagesList after -> ", bulkSavedImagesList);
					
					Shark.set({
						bulkSavedImagesList,
					});		
				}
				else {
					alert("Attenzione, si è verificato un errore con l'upload\n\nPer favore prova a ridimensionare l'immagine prima di inviarla, è troppo grande!");
					document.querySelector("#bulkUploadField").value = "";
				}
				
				// Dave: non è bello che ancora serva...
				Shark.render();				
			}

			waitBoxComponent.close();
		}
		else {
			alert("Devi selezionare un file");
		}
	}

	async uploadSingleFile (file, destFolder) {
		const url = Shark.$store.apiURL + "/image-content/upload";
		const formData = new FormData();

		formData.append("destFolder", destFolder || "");
		
		formData.append("files[]", file);

		const clientId = localStorage.getItem("NousCore.api.clientId") || "NA";
		const accessToken = localStorage.getItem("NousCore.api.accessKey") || "NA";
		const requestToken = localStorage.getItem("NousCore.api.last_token") || "";
		const userKey = localStorage.getItem("NousCore.api.user_key") || "";
		
		const timestamp = new Date().getTime();

		formData.append("__nctoken__", requestToken);
		formData.append("__ukey__", userKey);
		formData.append("payload[clientId]", clientId);
		formData.append("payload[accessToken]", accessToken);
		formData.append("payload[timestamp]", timestamp);

		const response = await fetch(url, {
			method: "POST",
			body: formData
		});
		
		const jsonData = await response.json();

		return jsonData;
	}
}

const imagesBulkUploadView = new ImagesBulkUploadView();

Shark.registerView(imagesBulkUploadView);

export default imagesBulkUploadView;